export default `<svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
        <!-- Fond vert avec un arrondi rx de 4 -->
        <rect fill="#8BC34A" height="32" rx="4" width="32" />

        <!-- Groupe avec le clipPath d'origine de 22x22 centré -->
        <g clip-path="url(#clip0)">
            <!-- Silhouette globale blanche du tube à essai avec son contenu -->
            <path d="M11 7.5C11 7.22386 11.2239 7 11.5 7H20.5C20.7761 7 21 7.22386 21 7.5C21 7.77614 20.7761 8 20.5 8H20V21.5C20 23.9853 17.9853 26 15.5 26C13.0147 26 11 23.9853 11 21.5V8H10.5C10.2239 8 10 7.77614 10 7.5Z" fill="white" />

            <!-- Découpe intérieure transparente pour dessiner les contours du tube et laisser le liquide au fond -->
            <path d="M12.5 8V19C12.5 19 13.5 19.5 15.5 18.5C17.5 17.5 18.5 18 18.5 18V8H12.5ZM12.5 19.5V21.5C12.5 23.1569 13.8431 24.5 15.5 24.5C17.1569 24.5 18.5 23.1569 18.5 21.5V18.5C18.5 18.5 17.2 17.8 15.2 19C13.5 20 12.5 19.5 12.5 19.5Z" fill="#8BC34A" />

            <!-- Bulles blanches au-dessus du liquide -->
            <circle cx="15" cy="13.5" fill="white" r="1.2" />
            <circle cx="17" cy="10.5" fill="white" r="0.8" />
        </g>

        <defs>
            <clipPath id="clip0">
                <rect fill="white" height="22" transform="translate(5 5)" width="22" />
            </clipPath>
        </defs>
    </svg>`;
